
<div [ngStyle]="{'height.rem': + heightRem}"></div>
